import { GzSetADIntegratorWebComponent } from './component/GzSetADIntegratorWebComponent';

export { GzSetADIntegratorWebComponent };
